import React from 'react'
import { useNavigate } from 'react-router-dom'

import "./article.css"

export default function Article(props) {
    const navigate = useNavigate();
  return (
    <div className='emas__article' onClick={() => navigate(`../${props.page}`)}>
        <img src={`../assets/images/articles/${props.coverImg}`} className="emas__article-img" alt='coverImg' />
        <div className='emas__article-heading'><h1>{props.title}</h1></div>
        <div className='emas__article-date'><i>{props.date}</i></div>
        <div className='emas__article-description'><p>{props.description}</p></div>
        {/* <div className='emas__article-button'>
          <button>Continue reading</button>
        </div> */}
    </div>
  )
}
